// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import { registerControllers } from "@radioactive-labs/plutonium"
registerControllers(application)

import WizardStepperController from "../../../packages/founder_portal/app/javascript/controllers/wizard_stepper_controller"
application.register("wizard-stepper", WizardStepperController)

import WizardNavController from "../../../packages/founder_portal/app/javascript/controllers/wizard_nav_controller"
application.register("wizard-nav", WizardNavController)

import MarketingNavController from "./marketing_nav_controller"
application.register("marketing-nav", MarketingNavController)

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)
